// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "flight__header-1D81v";
var _3 = "flightInfo-3tzCc";
var _4 = "flightInfo__inner-ANpD4";
var _5 = "flightInfo__col-2Wpjl";
var _6 = "flightInfo__col_time-29Ah8";
var _7 = "flightInfo__col_singleFare-3bHP3";
var _8 = "flightInfo__col__head-1-s_I";
var _9 = "flightInfo__col_head_duration-33uuk";
var _a = "flightInfo__col__sub-GMQhT";
var _b = "badge-1yDtV";
var _c = "col-1on5n";
var _d = "col_active-2KLVM";
var _e = "date-2b1gj";
var _f = "date_singleFare-1FIAJ";
var _10 = "dates__separator-bcbGO";
var _11 = "date__nextDayHint-2dlWO";
var _12 = "detailsLink-1QfMz";
var _13 = "detailsLink_active-1zqE6";
var _14 = "prices-2v5Ls";
var _15 = "flightInfo__inner_singleFare-CUdjX";
var _16 = "flightInfo__col_duration-1YGJj";
var _17 = "flightInfo__col_details-hkfGp";
export { _1 as "__esModule", _2 as "flight__header", _3 as "flightInfo", _4 as "flightInfo__inner", _5 as "flightInfo__col", _6 as "flightInfo__col_time", _7 as "flightInfo__col_singleFare", _8 as "flightInfo__col__head", _9 as "flightInfo__col_head_duration", _a as "flightInfo__col__sub", _b as "badge", _c as "col", _d as "col_active", _e as "date", _f as "date_singleFare", _10 as "dates__separator", _11 as "date__nextDayHint", _12 as "detailsLink", _13 as "detailsLink_active", _14 as "prices", _15 as "flightInfo__inner_singleFare", _16 as "flightInfo__col_duration", _17 as "flightInfo__col_details" }
export default { "__esModule": _1, "flight__header": _2, "flightInfo": _3, "flightInfo__inner": _4, "flightInfo__col": _5, "flightInfo__col_time": _6, "flightInfo__col_singleFare": _7, "flightInfo__col__head": _8, "flightInfo__col_head_duration": _9, "flightInfo__col__sub": _a, "badge": _b, "col": _c, "col_active": _d, "date": _e, "date_singleFare": _f, "dates__separator": _10, "date__nextDayHint": _11, "detailsLink": _12, "detailsLink_active": _13, "prices": _14, "flightInfo__inner_singleFare": _15, "flightInfo__col_duration": _16, "flightInfo__col_details": _17 }
